import { emperor } from '~/services';


export const fetchUnreadTextMessages = async () => {
  return await emperor.get('get-unread-texts');
};

export const markMessageAsRead = async (postFields: any) => {
  return await emperor.post('mark-texts-as-read', postFields);
};

export const removePhoneFromOutreach = async (postFields: any) => {
  return await emperor.post('remove-phone-from-outreach', postFields);
};
